// NGRX
import { Action } from '@ngrx/store';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { Update } from '@ngrx/entity';
import { OrderEvent } from '..';

export enum OrderEventActionTypes {
	OrderEventOnServerCreated = '[Edit OrderEvent Component] OrderEvent On Server Created',
	OrderEventCreated = '[Edit OrderEvent Component] OrderEvent Created',
	OrderEventUpdated = '[Edit OrderEvent Component] OrderEvent Updated',
	OrderEventsStatusUpdated = '[OrderEvents List Page] OrderEvents Status Updated',
	OneOrderEventDeleted = '[OrderEvents List Page] One OrderEvent Deleted',
	ManyOrderEventsDeleted = '[OrderEvents List Page] Many Selected OrderEvents Deleted',
	OrderEventsPageRequested = '[OrderEvents List Page] OrderEvents Page Requested',
	OrderEventsPageLoaded = '[OrderEvents API] OrderEvents Page Loaded',
	OrderEventsPageCancelled = '[OrderEvents API] OrderEvents Page Cancelled',
	OrderEventsPageToggleLoading = '[OrderEvents] OrderEvents Page Toggle Loading',
	OrderEventsActionToggleLoading = '[OrderEvents] OrderEvents Action Toggle Loading'
}

export class OrderEventOnServerCreated implements Action {
	readonly type = OrderEventActionTypes.OrderEventOnServerCreated;

	constructor(public payload: { OrderEvent: OrderEvent }) {
	}
}

export class OrderEventCreated implements Action {
	readonly type = OrderEventActionTypes.OrderEventCreated;

	constructor(public payload: { OrderEvent: OrderEvent }) {
	}
}

export class OrderEventUpdated implements Action {
	readonly type = OrderEventActionTypes.OrderEventUpdated;

	constructor(public payload: {
		partialOrderEvent: Update<OrderEvent>, // For State update
		OrderEvent: OrderEvent // For Server update (through service)
	}) {
	}
}

export class OrderEventsStatusUpdated implements Action {
	readonly type = OrderEventActionTypes.OrderEventsStatusUpdated;

	constructor(public payload: {
		OrderEvents: OrderEvent[],
		status: number
	}) {
	}
}

export class OneOrderEventDeleted implements Action {
	readonly type = OrderEventActionTypes.OneOrderEventDeleted;

	constructor(public payload: { id: number }) {
	}
}

export class ManyOrderEventsDeleted implements Action {
	readonly type = OrderEventActionTypes.ManyOrderEventsDeleted;

	constructor(public payload: { ids: number[] }) {
	}
}

export class OrderEventsPageRequested implements Action {
	readonly type = OrderEventActionTypes.OrderEventsPageRequested;

	constructor(public payload: { page: QueryParamsModel }) {
	}
}

export class OrderEventsPageLoaded implements Action {
	readonly type = OrderEventActionTypes.OrderEventsPageLoaded;

	constructor(public payload: { OrderEvents: OrderEvent[], totalCount: number, page: QueryParamsModel }) {
	}
}

export class OrderEventsPageCancelled implements Action {
	readonly type = OrderEventActionTypes.OrderEventsPageCancelled;
}

export class OrderEventsPageToggleLoading implements Action {
	readonly type = OrderEventActionTypes.OrderEventsPageToggleLoading;

	constructor(public payload: { isLoading: boolean }) {
	}
}

export class OrderEventsActionToggleLoading implements Action {
	readonly type = OrderEventActionTypes.OrderEventsActionToggleLoading;

	constructor(public payload: { isLoading: boolean }) {
	}
}

export type OrderEventsActions = OrderEventOnServerCreated
	| OrderEventCreated
	| OrderEventUpdated
	| OrderEventsStatusUpdated
	| OneOrderEventDeleted
	| ManyOrderEventsDeleted
	| OrderEventsPageRequested
	| OrderEventsPageLoaded
	| OrderEventsPageCancelled
	| OrderEventsPageToggleLoading
	| OrderEventsActionToggleLoading;
